// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-table .cell{padding-left:0;padding-right:0;word-break:break-word;font-size:14px}.table-row-name{font-weight:600}.allow-new-lines{white-space:pre-line}.label{font-size:15px}", ""]);
// Exports
module.exports = exports;
